import { createFileRoute } from '@tanstack/react-router'
import { ShoppingCart } from 'lucide-react'
import { z } from 'zod'
import { CheckoutScreen } from '@/screens/billing/SCR-161-checkout'

export const Route = createFileRoute('/_app/billing/checkout')({
  staticData: { screen: { id: 'SCR-161', title: 'Change plan', group: 'Organisation', perm: 'billing.manage', hidden: true, description: 'Review the change and pay securely with Razorpay.', icon: ShoppingCart } },
  validateSearch: z.object({
    plan: z.enum(['team', 'business']).optional(),
    interval: z.enum(['month', 'year']).optional(),
    seats: z.coerce.number().int().min(1).max(1000).optional(),
  }),
  component: function CheckoutRoute() {
    const s = Route.useSearch()
    const navigate = Route.useNavigate()
    return <CheckoutScreen plan={s.plan} interval={s.interval ?? 'month'} seats={s.seats} onChange={p => navigate({ search: prev => ({ ...prev, ...p }), replace: true })} />
  },
})
